import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider} from '@/components';
import type {AfriexQueryParams} from '@/types';

import PoolAccountUpdateButton from './PoolAccountUpdateButton';

export type BusinessPoolAccountsFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters?: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (search: string) => void;
};

const BusinessPoolAccountsFilters: React.FC<
  BusinessPoolAccountsFiltersProps
> = () => {
  return (
    <div className="mt-5 w-full">
      <div className="flex md:justify-end">
        {/* Status Select Box */}
        <PermissionsProvider
          permission={AfriexAdminPermission.BusinessPoolAccountManage}
        >
          <PoolAccountUpdateButton />
        </PermissionsProvider>
      </div>
    </div>
  );
};

export default BusinessPoolAccountsFilters;
